import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track16BBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track16BBlack" transform="translate(2384.000000, 414.000000)" className="track">
		<g id="line"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M28.5021351,54.0258862 C34.1059306,68.9850371 43.2118994,82.3840319 55.0576948,93.1011142 L111.072384,143.778508 C115.379574,147.675292 117.880451,153.181975 117.980482,158.989452 L119.009005,218.702155 L119.009005,218.702155"
			/>

			<TrackArrow
				transform="translate(119.125144, 217.037913) rotate(-91.000000) translate(-119.125144, -217.037913) "
				points="123.125144 225.037913 115.125144 217.037913 123.125144 209.037913"
			/>

			<line x1="119.226392" y1="231.32295" x2="121.138327" y2="271.419106"/>

			<path
				d="M0.5,0.5 C8.40440363,7.65357741 14.4806988,16.5961159 18.2205215,26.5794516 L24.7055916,43.8911364 L24.7055916,43.8911364"/>

			<TrackArrow
				transform="translate(23.865173, 41.436793) rotate(-111.000000) translate(-23.865173, -41.436793) "
				points="27.8651727 49.4367929 19.8651727 41.4367929 27.8651727 33.4367929"
			/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16BBlack')}
			coords="73.323688, 110.386522"
			text="16B"
			textCoordsX="6.92675781"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track16BBlack.propTypes = trackPropTypes;

export default Track16BBlack;
